export const routes = [
    {
        name: 'index',
        path: ['/', '/index.html'],
        page: 'example'
    },
]